
import { Component, Prop, Vue } from 'vue-property-decorator';

import { getStock } from '@/api/stock';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'StockChildrenList'
})
export default class extends Vue {
  // 当前层级的名称列表
  @Prop({
    type: Array,
    default: () => []
  })
  list!: any[];

  // 当前列表的父级库存 id（用于刷新当前层级）
  @Prop({
    type: [String, Number],
    default: ''
  })
  pid!: any;

  // 展开行：懒加载下级库存（库存列表接口传 pid 获取）
  private handleExpandChange(row: any, expandedRows: any[]) {
    const expanded = expandedRows.some((item: any) => item.id === row.id);
    if (expanded && !row.childrenx) {
      this.fetchChildren(row);
    }
  }

  private fetchChildren(row: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: row.id,
      page: 1,
      size: 9999
    };
    getStock(params)
      .then((res: any) => {
        const data = res.data;
        this.$set(row, 'childrenx', data && data.list ? data.list : []);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  // 刷新当前层级列表
  private refreshList() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: this.pid,
      page: 1,
      size: 9999
    };
    getStock(params)
      .then((res: any) => {
        const data = res.data;
        const list = data && data.list ? data.list : [];
        this.list.splice(0, this.list.length, ...list);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  private emitEditName(row: any) {
    this.$emit('edit-name', row, () => this.refreshList());
  }

  private emitAddChild(row: any) {
    this.$emit('add-child', row, () => this.refreshList());
  }

  private emitAddModel(row: any) {
    this.$emit('add-model', row, () => this.refreshList());
  }

  private emitDeleteName(row: any) {
    this.$emit('delete-name', row, () => this.refreshList());
  }

  private emitEditModel(model: any) {
    this.$emit('edit-model', model, () => this.refreshList());
  }

  private emitDeleteModel(model: any) {
    this.$emit('delete-model', model, () => this.refreshList());
  }

  private emitStockIn(model: any, name: any) {
    this.$emit('stock-in', model, name);
  }

  private emitStockOut(model: any, name: any) {
    this.$emit('stock-out', model, name);
  }

  private priceCount(row: any) {
    //20230720存在无库存的没有返回num
    if (row.num != undefined && row.unit_price != undefined) {
      return (parseFloat(row.unit_price) * parseFloat(row.num)).toFixed(2)
    } else {
      return '';
    }
  }

  private imgLargeHandle(val: any) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: 1
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
}
